var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFailedIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 158,
  height: 158,
  fill: "none",
  viewBox: "0 0 158 158",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#C2514B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 9,
  d: "m101.072 56.929-44.143 44.143m0-44.143 44.143 44.143M152.572 79c0 40.633-32.939 73.572-73.572 73.572C38.368 152.572 5.43 119.633 5.43 79 5.429 38.368 38.368 5.43 79 5.43c40.633 0 73.572 32.939 73.572 73.571"
})));
export { SvgFailedIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/failedIcon.svg";